/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 17 2024
 **/

import { css } from "@emotion/react";

export default function hoverScrollCss() {
	return css`
		overflow-y: auto;
		overflow-x: hidden;
		/* width: 100%; */

		/* 스크롤 y 넓이값 예외처리 */
		/* margin-right: -10px; */

		&::-webkit-scrollbar {
			background-color: transparent;
		}

		&::-webkit-scrollbar-thumb,
		&::-webkit-scrollbar-track {
			background-color: transparent;
			box-shadow: none;
		}

		&:hover::-webkit-scrollbar {
			/* width: 8px; */
			/* height: 8px; */
			background-color: transparent;
		}

		&:hover::-webkit-scrollbar-thumb {
			/* border-radius: 10px; */
			background-color: rgba(0, 0, 0, 0.4);
		}
	`;
}
